<template>
    <div class="rounded-[10px] mb-4 bg-[#2B2C32] w-full pb-4">
      <new-table-lite
        :class="'admin-template'"
        :is-loading="table.loading"
        :is-slot-mode='true'
        :columns="columns"
        :rows="table.rows"
        :rowClasses="customRowClass"
        :total="table.totalRecordCount"
        :sortable="table.sortable"
        :page-size='table.pagesize'
        @do-search="doSearch"
        @row-clicked="setActive"
        :pageOptions='table.pageOptions'
        :has-checkbox="false"
        :checked-return-type="'id'"
        :is-hide-paging="false"
        :pageSizeChangeLabel="'pageSizeChangeLabel'"
        :messages="{
          pagingInfo: 'Total: {2}',
          pageSizeChangeLabel: 'Items per Page',
          gotoPageLabel: '',
          noDataAvailable: 'No records found!',
        }"
      >
        <template v-slot:groupLocations="data">
          <span>{{ data.value.groupLocations?.length }}</span>
        </template>
        <template v-slot:baseLocationName="data">
          <span>{{ data.value.baseLocation?.name }}</span>
        </template>
      </new-table-lite>
    </div>
</template>

<script>
import  { defineComponent , ref} from "vue";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { useSnackbar } from "vue3-snackbar";
import moment from 'moment';
import Env from '@/env';
import PricingGroupApi from '@/controllers/PricingGroup'
import NewTableLite from '@/components/table/tableLite.vue'

export default defineComponent({
  name: 'ProductPricingList',
  components: {
    NewTableLite
  },
  props: {
    iscomponentactive: {
      type: Boolean,
      required: false,
    },
    selectedCallback: {
      type: Function,
      required: true,
    },
    clearComponent: {
      type: Function,
      required: true,
    },
  },
  setup() {
    const snackbar = useSnackbar();
    const activeItem = ref({});
    const dateRange = ref('')
    const columnsMain = ref([
      {
        label: "Name",
        field: "name",
        sortable: true,
      },
      {
        label: "# of Locations",
        field: "groupLocations",
        sortable: false,
      },
      {
        label: 'Base Location',
        field: 'baseLocationName',
        sortable: false,
      }
    ]);

    const table = ref({
      loading: false,
      rows: [],
      totalRecordCount: 0,
      count: 0,
      sortable: {
        order: "",
        sort: "",
      },
      pagesize: Env.defaultPageSize,
      pageOptions: Env.pageList,
      page: 1
    });

    return  {
      table,
      dateRange,
      columnsMain,
      activeItem,
      snackbar,
    };
  },

  async mounted() {
    this.fetchList(this.table.page);
    this.emitter.on("refresh-pricing-group-list", data => {
      this.fetchList(this.table.page);
    });
  },

  beforeDestroy() {
   this.emitter.off('refresh-pricing-group-list', () => {})
  },

  watch: {
    'vg_selectedLocation'(val) {
      // if location selected is changed fetch the data
      this.fetchList(this.table.page);
    },
    dateRange(){
      this.doSearch()
    }
  },

  computed: {
    ...mapGetters({
      vg_selectedLocation: 'location/selected'
    }),

    /**
     * Compute columns
     */
    columns() {
      return this.columnsMain;
    },
  },

  methods: {
    clearIt(){
      this.$refs.datePicker.clearValue()
    },
    /**
     * select row
     */
    selectedRow(item) {
       this.$router.push({
          name: 'ProductAuditsView',
          params: { id: item.id }
       })
    },
    /**
     * Fetch list
     */
    async fetchList(page) {
      this.table.loading = true
      let res = await PricingGroupApi.fetchAll(page?page:1, this.table.pagesize);
      this.table.rows = res.data.payload?.pricingGroups;
      this.table.totalRecordCount = (res.status == 200) ? res.data.payload?.totalRecords : 0
      this.table.page = page;
      this.table.loading = false
    },

    /**
     * Select the item
     */
    setActive(item) {
      let activeRow = document.getElementsByClassName('thisid_'+item.id);
      if(activeRow[0] && activeRow[0].parentNode && activeRow[0].parentNode.children){
        for(let sibling of activeRow[0].parentNode.children){
            sibling.classList.remove('active-row')
        }
      }
      activeRow[0].classList.add("active-row")

      this.selectedCallback(item);
    },

    /**
     * Create custom class on tr for active colors
     */
    customRowClass(item) {
      return 'cursor-pointer thisid_' + item.id;
    },

    formatDate(date){
      if(!date) return

      return moment(date).format('YYYY-MM-DD, hh:mm A')
    },

    /**
     * Search now
     */
    doSearch(offset, limit, order, sort) {
      let page = (offset/limit)+1
      this.table.sortable.order = order
      this.table.sortable.sort = sort
      this.table.pagesize = limit;
      this.table.page = page;
      this.fetchList(page);
    },

    ...mapActions({
      va_spinner: "spinner/setSpinner",
    })

  }
});
</script>